import React, { Component } from 'react';
import '../common/common.css';

class School extends Component {
  constructor(props) {
    super(props);
    this.state = {
        
    }
    
  }

  componentDidMount() {
    
  }

  

  

  componentWillUnmount() {
   
  }

 


	render() {

    		return (
			      <div className='schoolWrapper'>
                School here
            </div>
        )
	}
}



export default School;